import React from "react";
import useNoIndex from "./useNoIndex";

/**
 * Wraps protected pages (owner/*, guest/*) to inject a noindex meta tag.
 * This prevents search engines from indexing these pages even if they somehow
 * bypass robots.txt.
 */
const ProtectedRoute = ({ children }) => {
  useNoIndex();
  return <>{children}</>;
};

export default ProtectedRoute;
